<template>
<div class='vx-col w-full mt-4'>
    <!-- <vs-button type="border" v-if="permisoRoot" class="m-2 mt-3" to="/institucion/nueva">+ Agregar</vs-button> -->
    <section>
        <vs-table max-items="20" stripe search pagination :data="institucion" class="mt-4">
            <template slot="header">
                <vs-row>
                    <vs-col>
                        <vs-button type="border" v-if="permisoRoot" class="m-2 mt-3" @click="getNuevaEditar()">+ Agregar</vs-button>
                    </vs-col>
                    <vs-col>
                        Cantidad: {{institucion.length}}
                    </vs-col>
                </vs-row>

            </template>
            <template slot="thead">
                <vs-th>Nombre</vs-th>
                <vs-th>Region</vs-th>
                <vs-th>Periodo escolar</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="tr.nombreInstitucion">
                        {{tr.institucion.nombreInstitucion}}
                        <small v-if="tr.institucion.direccion != null">
                            <br>{{tr.institucion.direccion}}
                        </small><br>
                        <b>Asesor:</b>
                        <p>{{ tr.institucion.asesor }}</p>
                        <small class="text-success" v-if="tr.institucion.estado == 1">Activa</small>
                        <small class="text-danger" v-else>Inactiva</small>
                    </vs-td>

                    <vs-td :data="tr.institucion.region">
                        <span class="font-bold">Región:</span>
                        <p v-if="tr.institucion.region=='1'"> Sierra </p>
                        <p v-if="tr.institucion.region=='2'"> Costa </p>
                        <span class="font-bold">Provincia:</span>
                        <p>{{ tr.institucion.provincia }}</p>
                        <span>Creada: </span>{{tr.institucion.fecha_create}}
                    </vs-td>
                    <vs-td>
                        <span v-if="tr.periodo_escolar.length > 0">
                            {{ tr.periodo_escolar[0].periodo}} <br>
                            <b :class="tr.periodo_escolar[0].estado == 1 ? 'text-success' :'text-danger'">{{ tr.periodo_escolar[0].estadoPeriodo}}</b>
                        </span>
                        <span class="text-danger" v-else>Sin periodo asignado</span>
                    </vs-td>

                    <vs-td :data="tr.institucion.idinstitucion">
                        <div class="flex">
                            <vs-dropdown vs-custom-content vs-trigger-click>
                                <a class="a-icon cursor-pointer" href.prevent>
                                    <vs-button type="border" icon="menu"></vs-button>
                                </a>

                                <vs-dropdown-menu>
                                    <vs-dropdown-item>
                                        <vs-button style="width: 200px" type="line" color="#b2471e" @click="periodos(tr.institucion)">Periodos</vs-button>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        <vs-button style="width: 200px" type="line" color="success" @click="informacion(tr.institucion)">Usuarios</vs-button>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        <vs-button style="width: 200px" type="line" color="warning" @click="getNuevaEditar(tr.institucion.idinstitucion)">Editar</vs-button>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
    </section>
    <section class="modal-periodos">
        <vs-popup fullscreen title="Asignación de periodos" :active.sync="modalPeriodosAsignar" :class="{ 'hide-close': !showCloseButton }">
            <PeriodosInstitucion v-if="modalPeriodosAsignar" @changePeriodo="changePeriodo()" @quitarPeriodo="quitarPeriodo()" />
        </vs-popup>
    </section>
    <section class="modal-nuevo-editar-institucion">
        <vs-popup fullscreen title="Institución" :active.sync="modalInstitucion" :class="{ 'hide-close': !showCloseButton }">
            <NuevaInstitucion v-if="modalInstitucion" @changeInstitucion="changeInstitucion()" />
        </vs-popup>
    </section>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import GeneralMixin from "@/mixins/GeneralMixin";
import PeriodosInstitucion from '../periodos/periodosInstitucion.vue';
import NuevaInstitucion from './nueva.vue';
Vue.use(axios)
export default {
    name: 'InstitucionesVue',
    components: {
        PeriodosInstitucion,
        NuevaInstitucion,
    },
    mixins: [GeneralMixin],
    data() {
        return {
            usuario: [],
            institucion: [],
            id_eliminar: '',
            permisoRoot: false,
            modalPeriodosAsignar: false,
            showCloseButton: false,
            modalInstitucion: false,
        }
    },
    mounted() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
        me.getUserRoot().then(r => {
            if (r.data.length > 0) {
                me.permisoRoot = true
            }
        })
        localStorage.removeItem('institucion')
        localStorage.removeItem('idinstitucion')
        me.getInstitucion();
    },
    methods: {
        getInstitucion() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'institucion')
                .then(response => {
                    me.institucion = response.data;
                    // console.log(me.institucion)
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();
                })
        },
        getNuevaEditar(item) {
            let me = this;
            localStorage.idinstitucion = item
            me.modalInstitucion = true;
            // this.$router.push('/institucion/editar/' + institucion);
            // console.log(institucion);
        },
        confirmaEliminar(institucion) {
            let me = this;
            me.id_eliminar = institucion;
            me.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                acceptText: 'Aceptar',
                title: `Confirmación`,
                text: 'Estas seguro de eliminar, esta institución?.',
                accept: me.getEliminar
            })
        },
        getEliminar() {
            let me = this;
            me.$http.delete(this.$server_url + 'institucion/' + me.id_eliminar)
                .then(() => {
                    me.getInstitucion();
                })
                .catch(() => {})
        },
        informacion(item) {
            localStorage.institucion = JSON.stringify(item);
            this.$router.push('/institucion/detalle');
        },
        periodos(item) {
            console.log(item)
            localStorage.institucion = JSON.stringify(item);
            // this.$router.push('/periodosInstitucion');
            this.modalPeriodosAsignar = true;
        },
        changeInstitucion() {
            let me = this;
            me.modalInstitucion = false;
            me.getInstitucion();
        },
        changePeriodo() {
            let me = this;
            me.modalPeriodosAsignar = false;
            me.getInstitucion();
        },
        quitarPeriodo() {
            let me = this;
            me.getInstitucion();
        }
    },
}
</script>
